import React from 'react'
import './Dash.css'
import NavBar from '../Components/NavBar'
import LeftBar from '../Components/LeftBar'
import OrdersComp from './OrdersComp'

function Orders() {
  return (
    <div className='contentMain'>
      <LeftBar />
      <div className='theRightOne'>
        <div className='DashTop'>
          <h1>Orders</h1>
          <NavBar />
        </div>
        <OrdersComp />
      </div>
    </div>
  )
}

export default Orders